import ProductListFilter from "../filter/ProductListFilter";
import productCardClickService from "../../services/ProductCardClickService";
import luigisboxAnanyticsService from "../../luigisbox/luigisboxAnanyticsService";
import elementService from "@/common/ElementService";

export class FilterChangedEvent extends Event {
    public static readonly Type = "filterchanged";

    constructor() {
        super(FilterChangedEvent.Type);
    }
}

export default class ProductListBrowseContentContainer extends EventTarget {
    private readonly productListContainer: HTMLDivElement;

    constructor(private readonly productListFilter: ProductListFilter) {
        super();

        this.productListContainer = elementService.querySelector<HTMLDivElement>("#js-product-list-container");
    }

    public initContent(): void {
        this.initClickOnProductCards();
        this.initSortingButtons();
        this.initPagingButtons();
        this.initShowMoreProductButtons();
        this.performLuigisboxAnalytics();
    }

    private initClickOnProductCards(): void {
        productCardClickService.initForContainer(this.productListContainer);
    }

    private initSortingButtons(): void {
        for (const sortBySpan of this.productListContainer.querySelectorAll<HTMLSpanElement>(".js-product-sort")) {
            sortBySpan.addEventListener("click", () => this.setProductListSort(sortBySpan));
        }
    }

    private setProductListSort(sortBySpan: HTMLSpanElement): void {
        this.productListFilter.setSort(elementService.elementData(sortBySpan, "sortBy"));
        this.dispatchEvent(new FilterChangedEvent());
    }

    private initPagingButtons(): void {
        for (const goToPageAnchor of this.productListContainer.querySelectorAll<HTMLSpanElement>(".js-product-go-to-page")) {
            goToPageAnchor.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();
                this.goToProductListPage(goToPageAnchor);
            });
        }
    }

    private goToProductListPage(goToPageAnchor: HTMLSpanElement): void {
        const page = elementService.elementData(goToPageAnchor, "page");

        this.productListFilter.setPage(Number.parseInt(page));

        if (goToPageAnchor.dataset.scrollTop === "true") {
            this.scrollPageToTop();
        }

        this.dispatchEvent(new FilterChangedEvent());
    }

    private scrollPageToTop(): void {
        const targetScroll = this.productListContainer.offsetTop - 82;
        window.scrollTo({ top: targetScroll, behavior: "smooth" });
    }

    private initShowMoreProductButtons(): void {
        for (const showMorePageAnchor of this.productListContainer.querySelectorAll<HTMLSpanElement>(".js-product-show-more-page")) {
            showMorePageAnchor.addEventListener("click", (event: MouseEvent) => {
                event.preventDefault();
                this.showMoreProductListPage();
            });
        }
    }

    private showMoreProductListPage(): void {
        this.productListFilter.increasePagesCount();
        this.dispatchEvent(new FilterChangedEvent());
    }

    private performLuigisboxAnalytics(): void {
        luigisboxAnanyticsService.performLuigisboxAnalytics();
    }
}
